<!--
 * @Date: 2023-01-28 12:08:36
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2023-02-08 10:09:32
 * @FilePath: \nicee-web-tw\src\activities\spring-festival\star-year.vue
 * @Description: 决赛阶段
-->
<template>
  <div class="star-year">
    <div class="main">
      <img class="img-header" src="./images/star-year-header.png" alt="" />
      <div class="rank-list">
        <div
          class="rank-item no1"
          v-if="rankList[0]"
          @click="toPlayerDetail(rankList[0])"
        >
          <img src="./images/star-year-no1.png" alt="" class="avatar-border" />
          <div class="avatar-box">
            <img :src="rankList[0].avatarUrl" alt="" class="avatar" />
          </div>
          <div class="boss-box" v-if="topBoss[0]" @click.stop>
            <img :src="topBoss[0].avatarUrl" alt="" class="avatar" />
          </div>
        </div>
        <div
          class="rank-item no2"
          v-if="rankList[1]"
          @click="toPlayerDetail(rankList[1])"
        >
          <img :src="rankList[1].avatarUrl" alt="" class="avatar" />
          <img
            src="./images/star-year-no2.png"
            alt=""
            class="star-year-no-icon"
          />
          <span class="user-name">
            {{ rankList[1].nickname }}
          </span>
          <span> uid: {{ rankList[1].userUuid }} </span>
        </div>
        <div
          class="rank-item no3"
          v-if="rankList[2]"
          @click="toPlayerDetail(rankList[2])"
        >
          <img :src="rankList[2].avatarUrl" alt="" class="avatar" />
          <img
            src="./images/star-year-no3.png"
            alt=""
            class="star-year-no-icon"
          />
          <span class="user-name">
            {{ rankList[2].nickname }}
          </span>
          <span>
            <span> uid: {{ rankList[2].userUuid }} </span>
          </span>
        </div>
      </div>
      <div class="rank-list2" v-if="topBoss.slice(0, 8)">
        <div class="jewel-title">
          <img class="jewel left" src="./images/jewel.png" alt="" />
          <span>盛典boss</span>
          <img class="jewel" src="./images/jewel.png" alt="" />
        </div>
        <div class="rank-box">
          <div
            class="rank-item"
            v-for="item of topBoss.slice(0, 8)"
            :key="item.userUuid"
          >
            <img :src="item.avatarUrl" alt="" class="avatar" />
            <span class="user-name">
              {{ item.nickname }}
            </span>
            <span> id:{{ item.userUuid }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'StarYear',
  components: {},
  props: {
    activityData: {
      typeof: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      selectedPlayer: null
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['userInfo']),
    //獲獎排名
    rankList() {
      try {
        return this.activityData.appendInfo.topPlayer || [];
      } catch (error) {
        return [];
      }
    },
    topBoss() {
      try {
        return this.activityData.appendInfo.topBoss || [];
      } catch (error) {
        return [];
      }
    },
    appendInfo() {
      try {
        return this.activityData.appendInfo || {};
      } catch (error) {
        return {};
      }
    }
  },
  methods: {
    // 查看陪玩師詳情
    toPlayerDetail(userInfo) {
      if (userInfo && userInfo.userUuid) {
        this.$router.push({
          path: `/player-detail/${userInfo.userUuid}`
        });
      }
    },
    refresh() {
      this.$emit('refresh');
    }
  }
};
</script>
<style lang="scss" scoped>
.star-year {
  > .main {
    font-size: 1.67rem;
    color: #e9cc95;
    width: 100.08rem;
    margin-top: 9.83rem;
    margin-bottom: 6rem;
    position: relative;
    background: #371c04;
    border: 1px solid #eabf7c;
    border-radius: 2rem;
    padding-bottom: 5rem;
    .img-header {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translate(-50%, -50%);
      width: 31.58rem;
      height: 7.25rem;
    }
    .rank-list {
      // margin-left: -18px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .no1 {
        position: relative;
        width: 71.33rem;
        height: 42.67rem;
        margin-top: 9.83rem;
        margin-bottom: 8rem;
        flex: none;
        .avatar-border {
          width: 100%;
          height: 100%;
          position: absolute;
          z-index: 2;
        }
        .avatar-box {
          position: absolute;
          width: 65.67rem;
          height: 32.33rem;
          background: url('./images/no1-empty.png') no-repeat center top;
          background-size: 100% auto;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
          .avatar {
            position: absolute;
            width: 50%;
            height: 32.2rem;
            left: 50%;
            bottom: 0rem;
            transform: translateX(-50%);
            object-fit: cover;
          }
        }

        .boss-box {
          width: 22.83rem;
          height: 20.58rem;
          background: url('./images/boss-bg.png') no-repeat center top;
          background-size: 100% auto;
          position: absolute;
          right: -4rem;
          top: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;
          .avatar {
            width: 13.83rem;
            height: 13.83rem;
            border-radius: 50%;
            object-fit: cover;
            margin-top: 0.5rem;
          }
        }
      }
      .no2,
      .no3 {
        width: 30.42rem;
        height: 49.33rem;
        background: url('./images/star-year-no.png') no-repeat center top;
        background-size: 100% auto;
        flex: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #ffffff;
        font-size: 2.43rem;
        line-height: 2rem;
        .user-name {
          margin-top: 2rem;
        }
        .avatar {
          width: 15.83rem;
          height: 15.83rem;
          border-radius: 50%;
          object-fit: cover;
          margin-top: 11.83rem;
        }
        .star-year-no-icon {
          width: 20.33rem;
          height: 5.58rem;
        }
      }
      .no2 {
        margin-right: 8.33rem;
      }
    }
    .rank-list2 {
      .jewel-title {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 4rem;
        margin-top: 4rem;
        margin-bottom: 2rem;
        .jewel {
          width: 2rem;
          margin: 0 0.2rem;
        }
      }
      .rank-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .rank-item {
          // 15 23
          width: 20rem;
          height: 30.67rem;
          background: url('./images/star-year-no-bg.png') no-repeat center top;
          background-size: 100% auto;
          margin-right: 0.4rem;
          margin-top: 3rem;
          display: flex;
          flex-direction: column;
          align-items: center;
          font-size: 1rem;
          .avatar {
            width: 14rem;
            height: 14rem;
            border-radius: 50%;
            object-fit: cover;
            margin-top: 5.6rem;
            margin-bottom: 2rem;
          }
          .user-name {
            margin-top: 2rem;
            width: 60%;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
